import { createPortal } from "react-dom";
import { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import FileViewer from './FileViewer'
import SendInterestModal from "./IndependentResearcher/SendInterestModal";
const BASE_URL = process.env.REACT_APP_BASE_URL;
const MarketPlaceOpportunityDetails = () => {
    const navigate = useNavigate()
    const { id } = useParams();
  const [searchParams] = useSearchParams();
  const research_type = searchParams.get("research_type");
  const type = searchParams.get("type");
  const [pubExpanded, setPubExpanded] = useState(false);
  const [post, setPost] = useState(null);
  // console.log("The post is:",post)
     const [open,setOpen] = useState(false)
      const handleClose = () => {
    navigate(-1)
  };

  useEffect(()=>{
     if(!id) return;
      const fetchPostDetails = async () => {
          try {
             const response = await axios.get(`${BASE_URL}/marketplace/researcher/feed/${id}?research_type=${research_type}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('access_token')}`,
          'x-api-key': process.env.REACT_APP_X_API_KEY,
        },
      });
            //  console.log("Post details:", response.data);
             setPost(response.data);
          } catch (error) {
              console.error("Error fetching post details:", error);
          }
        }
        fetchPostDetails();
  },[id,research_type, type])
  return(
  <>
       
          
    <div className="md:h-screen w-full px-0 md:px-6 bg-white backdrop-blur-[20px] shadow-[0_4px_6px_-1px_rgba(0,0,0,0.02),0_10px_15px_-3px_rgba(0,0,0,0.03),0_0_0_1px_rgba(255,255,255,0.5)] hover:shadow-[0_20px_40px_-8px_rgba(0,0,0,0.08),0_0_0_1px_rgba(255,255,255,0.8)] hover:-translate-y-[1px] transition-all duration-300 overflow-hidden">
        {/* <!-- Top Bar: Close Left, Interest Right --> */}
      <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100/80">
        <button onClick={handleClose} className="w-10 h-10 rounded-full bg-gray-100/80 hover:bg-gray-200/80 flex items-center justify-center text-gray-500 hover:text-gray-700 transition-all duration-200 hover:scale-105">
          <span className="text-lg">✕</span>
        </button>
        <div className="flex items-center gap-3">
          <span className="hidden sm:inline text-sm text-gray-400">Interested in this project?</span>
          <button 
          onClick={() => setOpen(true)} 
          className="px-6 py-2.5 bg-[#0f6abf] text-white rounded-xl hover:bg-[#0a5ca8] font-semibold shadow-sm transition-all duration-200"
        >
          Send Interest
        </button>
        </div>
      </div>
        {/* <!-- Content Area --> */}
      <div className="p-3 md:p-8">
          {/* <!-- Header: Name + Maturity Badge --> */}
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mb-8">
          <div>
            <p className="text-xs font-semibold text-gray-400 uppercase tracking-widest mb-1">Research Details</p>
            <h1 className="text-3xl font-bold text-gray-900 tracking-tight">{post?.name}</h1>
          </div>
          <span className="self-start inline-flex items-center gap-1.5 px-4 py-2 bg-emerald-50 text-emerald-700 rounded-full text-sm font-semibold border border-emerald-100">
            <span className="w-1.5 h-1.5 rounded-full bg-emerald-500"></span>
             {post?.maturity}
          </span>
        </div>
         {/* <!-- Stats Row --> */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 mb-8">
          <div className="bg-white/60 backdrop-blur-sm rounded-2xl p-4 border border-gray-100/80 flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-blue-50 flex items-center justify-center flex-shrink-0">
              <svg className="w-5 h-5 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9" />
              </svg>
            </div>
            <div>
              <p className="text-xs font-medium text-gray-400 uppercase tracking-wide">Domain</p>
              <p className="text-base font-semibold text-gray-800">{post?.domain}</p>
            </div>
          </div>
          <div className="bg-white/60 backdrop-blur-sm rounded-2xl p-4 border border-gray-100/80 flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-green-50 flex items-center justify-center flex-shrink-0">
              <svg className="w-5 h-5 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
              </svg>
            </div>
            <div>
              <p className="text-xs font-medium text-gray-400 uppercase tracking-wide">Publisher</p>
              <p className="text-base font-semibold text-gray-800">{post?.publisher}</p>
            </div>
          </div>
          <div className="bg-white/60 backdrop-blur-sm rounded-2xl p-4 border border-gray-100/80 flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-yellow-50 flex items-center justify-center flex-shrink-0">
              <svg className="w-5 h-5 text-yellow-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
              </svg>
            </div>
            <div>
              <p className="text-xs font-medium text-gray-400 uppercase tracking-wide">Visibility</p>
              <p className="text-base font-semibold text-gray-800">{post?.visibility}</p>
            </div>
          </div>
          <div className="bg-white/60 backdrop-blur-sm rounded-2xl p-4 border border-gray-100/80 flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-purple-50 flex items-center justify-center flex-shrink-0">
              <svg className="w-5 h-5 text-purple-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
              </svg>
            </div>
            <div>
              <p className="text-xs font-medium text-gray-400 uppercase tracking-wide">Collaboration</p>
              <p className="text-base font-semibold text-indigo-600">{post?.collaboration}</p>
            </div>
          </div>
          <div className="bg-white/60 backdrop-blur-sm rounded-2xl p-4 border border-gray-100/80 flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center flex-shrink-0">
              <svg className="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
            </div>
            <div>
              <p className="text-xs font-medium text-gray-400 uppercase tracking-wide">Created At</p>
              <p className="text-base font-semibold text-gray-800">{new Date(post?.created_at).toLocaleDateString("en-GB", {
  day: "2-digit",
  month: "short",
  year: "numeric",
})}</p>
            </div>
          </div>
          <div className="bg-white/60 backdrop-blur-sm rounded-2xl p-4 border border-gray-100/80 flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-indigo-50 flex items-center justify-center flex-shrink-0">
              <svg className="w-5 h-5 text-indigo-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
              </svg>
            </div>
            <div>
              <p className="text-xs font-medium text-gray-400 uppercase tracking-wide">Total Applicants</p>
              <p className="text-base font-semibold text-gray-800">{post?.total_applied_count || 0} Applied</p>
            </div>
          </div>
        </div>
                {/* <!-- Main Grid: Content + Sidebar --> */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">

          {/* <!-- Left Main Content --> */}
          <div className="lg:col-span-2 space-y-6">

            {/* <!-- Summary --> */}
           <div className="bg-[#e8f0f7]/30 rounded-xl p-5 border border-[#0f6abf]/10">
  <div className="flex items-center gap-2 mb-3">
     <div className="w-8 h-8 bg-white rounded-lg flex items-center justify-center">
                <svg className="w-4 h-4 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>

    <h2 className="text-lg font-bold text-blue-700">Summary</h2>
  </div>

  <div className="max-h-[10vh] overflow-y-auto pr-2">
    <p className="text-gray-700 leading-relaxed">
      {post?.summary}
    </p>
  </div>
</div>

            {/* <!-- Full Details --> */}
           <div className="bg-gray-50 rounded-2xl p-6 relative overflow-hidden border border-gray-200">
  
  <div className="flex items-center gap-2 mb-3 relative z-10">
     <div className="w-8 h-8 bg-white rounded-lg flex items-center justify-center">
                <svg className="w-4 h-4 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                </svg>
              </div>
    <h2 className="text-lg font-bold text-gray-800">Full Details</h2>
  </div>

  <div className="max-h-[22vh] overflow-y-auto relative z-10 pr-2">
    <p className="text-sm text-gray-700 leading-relaxed">
      {post?.description}
    </p>
  </div>
             
</div>
</div>

          {/* <!-- Right Sidebar: File --> */}
          <div className="lg:col-span-1">
<div className="bg-white/70 h-[60vh] flex flex-col backdrop-blur-sm rounded-2xl border border-gray-100/80 overflow-hidden sticky top-6">              <div className="p-4 border-b border-gray-100">
                <div className="flex items-center gap-2">
                  <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13" />
                  </svg>
                  <h2 className="text-base font-semibold text-gray-800">Attached File</h2>
                </div>
              </div>
              <div className="relative group overflow-hidden flex-1">
                  <FileViewer publication_type={post?.publication_type} file={post?.file} name={post?.name}/>
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors duration-300"></div>
              </div>
              <div className="p-4">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="font-semibold text-gray-800">{post?.publication_type}</p>
                  </div>
                  <button onClick={() => window.open(post?.file, "_blank")} className="w-9 h-9 rounded-full bg-indigo-50 hover:bg-indigo-100 flex items-center justify-center transition-colors duration-200 group/download" title="Download file">
                    <svg className="w-4 h-4 text-indigo-600 group-hover/download:text-indigo-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>

      </div>
    </div>
            
       </div>
    <SendInterestModal isOpen={open} onClose={() => setOpen(false)} postId = {id} research_type = {research_type} postOwnerId={post?.profile_data?.user} />
  </>
  )
};

export default MarketPlaceOpportunityDetails;